module.exports = "/static/assets/968680284c4fc84e16ab59b33e9515d4.png";